import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
var NotFoundPage = function NotFoundPage() {
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "404: Seite nicht gefunden"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Error 404"), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 text-center"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl mb-2"
    }, "Seite nicht gefunden"), /*#__PURE__*/ React.createElement("p", null, "Leider konnte die angefragte Seite nicht gefunden werden."))));
};
export default NotFoundPage;
